import { render, staticRenderFns } from "./entry_index.vue?vue&type=template&id=b5865d58&scoped=true"
import script from "./entry_index.vue?vue&type=script&lang=js"
export * from "./entry_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5865d58",
  null
  
)

export default component.exports